<template>
  <div class="container-fluid benjamin-moore-container">
    <div class="wf-page-controls mt-4 mt-lg-0">
      <div class="wf-page-controls-items">
        <div
          class="wf-page-control-item wf-page-control-item-current-refinements"
        >
          <benjamin-current-filter></benjamin-current-filter>
        </div>
        <div
          class="
            wf-page-control-item wf-page-control-item-product-display-controls
          "
        >
          <div class="wf-product-display-controls">
            <div
              class="wf-product-display-control wf-product-display-control-filter"
            >
              <button
                class="wf-side-collapse-button wf-side-collapse-button-open btn shadow"
                @click="filterSideBar"
                type="button"
              >
                <span class="pr-3">{{
                  $resourceString["product.search.display.filter"]
                }}</span>
                <span
                  class="png-icon png-icon-icons-glyph--k-sort-filter m-0"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wf-product-category">
      <div class="wf-product-category-sidebar-mobile">
        <div class="wf-side-collapse" id="filters-side-collapse">
          <div class="wf-side-collapse-header justify-content-end">
            <button
              class="wf-side-collapse-button wf-side-collapse-button-close btn"
              type="button"
              @click="filterSideBar"
            >
              {{ $resourceString["product.search.close.button"] }}
              <span
                class="png-icon png-icon-icons-glyph--g-close"
                aria-label="close button"
              />
            </button>
          </div>
          <div class="wf-side-collapse-body">
            <div class="wf-side-collapse-section">
              <benjamin-current-filter></benjamin-current-filter>
            </div>
            <div class="wf-side-collapse-section">
              <side-filter />
            </div>
          </div>
        </div>
      </div>
      <div class="wf-product-category-sidebar-desktop">
        <side-filter />
      </div>

      <div class="wf-product-category-results">
        <section class="wf-product-category-results-section">
          <div class="container-fluid">
            <h2 class="secondary-heading">
              {{ $resourceString["benjaminMoore.Title"] }}
            </h2>

            <benjamin-search-bar></benjamin-search-bar>
            <div class="wf-product-category-results">
              <benjamin-search-result
                :results="results"
              ></benjamin-search-result>
              <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
              <p v-if="results.length === 0 && !isFetching">
                {{ $resourceString["comon.noResults"] }}
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import BenjaminSearchResult from "./benjamin-moore-result.vue";
import BenjaminSearchBar from "./benjamin-moore-search.vue";
import SideFilter from "./benjamin-moore-filter.vue";
import BenjaminCurrentFilter from "./benjamin-current-filter.vue";
import { mapGetters, mapActions } from "vuex";
import PcLoadMore from "../common/pc-loading-more.vue";
export default {
  data() {
    return {};
  },
  components: {
    BenjaminSearchResult,
    SideFilter,
    PcLoadMore,
    BenjaminSearchBar,
    BenjaminCurrentFilter
  },
  computed: {
    ...mapGetters({
      results: "benjaminMoore/results",
      isFetching: "benjaminMoore/isFetching",
      showLoadMore: "benjaminMoore/showLoadMore",
      pageNumber: "benjaminMoore/pageNumber",
      selectedColor: "benjaminMoore/selectedColor"
    })
  },
  methods: {
    ...mapActions({
      getBenjaminMooreProducts: "benjaminMoore/getBenjaminMooreProducts",
      setPageNumber: "benjaminMoore/setPageNumber"
    }),
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.setPageNumber(this.pageNumber + 1);
    },
    filterSideBar() {
      if(document.getElementById("filters-side-collapse").classList.contains('wf-side-collapse-active'))
      {
        document.getElementById("filters-side-collapse").classList.remove("wf-side-collapse-active");
      }
      else
      {
        document.getElementById("filters-side-collapse").classList.add("wf-side-collapse-active");
      }
    }
  },
  created() {
    // Watching data from URL
    const urlParams = new URLSearchParams(window.location.search);
    let data = {}
    if(urlParams.has('colors'))
    {
      data.color = urlParams.get('colors');
      data.color = data.color.split(",");
    }
    if(urlParams.has('searchTerm'))
    {
      data.searchTerm = urlParams.get('searchTerm');
    }

    this.getBenjaminMooreProducts(data);
  }
};
</script>
